import { render } from "./SignHint.vue?vue&type=template&id=049d58b2"
import script from "./SignHint.vue?vue&type=script&lang=js"
export * from "./SignHint.vue?vue&type=script&lang=js"

import exportComponent from "/opt/goodtoknow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__